'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _context = require('@prisma-cms/context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ContextProvider = (_temp = _class = function (_PureComponent) {
  _inherits(ContextProvider, _PureComponent);

  function ContextProvider() {
    _classCallCheck(this, ContextProvider);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  ContextProvider.prototype.render = function render() {
    var children = this.props.children;
    var query = this.context.query;
    Object.assign(this.context, {
      query: _extends({}, query, this.prepareQuery())
    });
    return _react2.default.createElement(_context2.default.Provider, {
      value: this.context
    }, children || null);
  };

  ContextProvider.prototype.prepareQuery = function prepareQuery() {
    return _extends({}, this.prepareCallRequestQuery());
  };

  ContextProvider.prototype.prepareCallRequestQuery = function prepareCallRequestQuery() {
    var queryFragments = this.context.queryFragments;
    var ChatRoomNoNestingFragment = queryFragments.ChatRoomNoNestingFragment,
        CallRequestNoNestingFragment = queryFragments.CallRequestNoNestingFragment,
        UserNoNestingFragment = queryFragments.UserNoNestingFragment,
        BatchPayloadNoNestingFragment = queryFragments.BatchPayloadNoNestingFragment;
    var callRequestFragment = '\n      fragment callRequest on CallRequest {\n        ...CallRequestNoNesting\n        Called{\n          ...UserNoNesting\n        }\n        Caller{\n          ...UserNoNesting\n        }\n        Room{\n          ...ChatRoomNoNesting\n          Members{\n            ...UserNoNesting\n          }\n        }\n      }\n\n      ' + CallRequestNoNestingFragment + '\n      ' + UserNoNestingFragment + '\n      ' + ChatRoomNoNestingFragment + '\n    ';
    var callRequestsConnection = '\n      query callRequestsConnection (\n        $where: CallRequestWhereInput\n        $orderBy: CallRequestOrderByInput\n        $skip: Int\n        $after: String\n        $before: String\n        $first: Int\n        $last: Int\n      ){\n        objectsConnection: callRequestsConnection (\n          where: $where\n          orderBy: $orderBy\n          skip: $skip\n          after: $after\n          before: $before\n          first: $first\n          last: $last\n        ){\n          aggregate{\n            count\n          }\n          edges{\n            node{\n              ...callRequest\n            }\n          }\n        }\n      }\n\n      ' + callRequestFragment + '\n    ';
    var callRequests = '\n      query callRequests (\n        $where: CallRequestWhereInput\n        $orderBy: CallRequestOrderByInput\n        $skip: Int\n        $after: String\n        $before: String\n        $first: Int\n        $last: Int\n      ){\n        objects: callRequests (\n          where: $where\n          orderBy: $orderBy\n          skip: $skip\n          after: $after\n          before: $before\n          first: $first\n          last: $last\n        ){\n          ...callRequest\n        }\n      }\n\n      ' + callRequestFragment + '\n    ';
    var callRequest = '\n      query callRequest (\n        $where: CallRequestWhereUniqueInput!\n      ){\n        object: callRequest(\n          where: $where\n        ){\n          ...callRequest\n        }\n      }\n\n      ' + callRequestFragment + '\n    ';
    var createCallRequestProcessor = '\n      mutation createCallRequestProcessor(\n        $data: CallRequestCreateInput!\n      ) {\n        response: createCallRequestProcessor(\n          data: $data\n        ){\n          success\n          message\n          errors{\n            key\n            message\n          }\n          data{\n            ...callRequest\n          }\n        }\n      }\n\n      ' + callRequestFragment + '\n    ';
    var updateCallRequestProcessor = '\n      mutation updateCallRequestProcessor(\n        $data: CallRequestUpdateInput!\n        $where: CallRequestWhereUniqueInput!\n      ) {\n        response: updateCallRequestProcessor(\n          data: $data\n          where: $where\n        ){\n          success\n          message\n          errors{\n            key\n            message\n          }\n          data{\n            ...callRequest\n          }\n        }\n      }\n\n      ' + callRequestFragment + '\n    ';
    var deleteCallRequest = '\n      mutation deleteCallRequest (\n        $where: CallRequestWhereUniqueInput!\n      ){\n        deleteCallRequest(\n          where: $where\n        ){\n          ...CallRequestNoNesting\n        }\n      }\n      ' + CallRequestNoNestingFragment + '\n    ';
    var deleteManyCallRequests = '\n      mutation deleteManyCallRequests (\n        $where: CallRequestWhereInput\n      ){\n        deleteManyCallRequests(\n          where: $where\n        ){\n          ...BatchPayloadNoNesting\n        }\n      }\n      ' + BatchPayloadNoNestingFragment + '\n    ';
    return {
      callRequestsConnection: callRequestsConnection,
      callRequests: callRequests,
      callRequest: callRequest,
      createCallRequestProcessor: createCallRequestProcessor,
      updateCallRequestProcessor: updateCallRequestProcessor,
      deleteCallRequest: deleteCallRequest,
      deleteManyCallRequests: deleteManyCallRequests
    };
  };

  return ContextProvider;
}(_react.PureComponent), _class.contextType = _context2.default, _temp);
exports.default = ContextProvider;
module.exports = exports['default'];